<script setup>
defineProps({
	href: {
		type: String,
		default: '#',
	},
})
</script>

<template>
	<div class="my-2 flex justify-end px-2">
		<a :href="href" class="text-snk-blue-500 hover:text-snk-blue-700 inline-flex items-center gap-1.5 text-sm transition-colors duration-200" target="_blank">
			<i class="far fa-info-circle" />
			<slot>
				<span class="max-md:hidden">Report an issue with this leaderboard</span>
				<span class="md:hidden">Report an issue</span>
			</slot>
		</a>
	</div>
</template>
